import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-layout-example',
  templateUrl: './layout.component.html',
})
export class KitBootstrapLayoutExampleComponent {}
